import { combineReducers } from "redux"
import authenticate from "./authenticate/authenticate"
import appointment from "./appointment/appointment"
import generalInfo from "./generalInfo/generalInfo"
import calendar from "./calendar/calendar"
import history from "./history/history"
import businessClient from "./businessClient/businessClient"
import staffNotification from "./notification/staffNotificationReducer"
const appReducer = combineReducers({
    authenticate,
    generalInfo,
    appointment,
    calendar,
    history,
    businessClient,
    staffNotification
})

const initialState = appReducer({}, {})


const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT' || action.type === "LOGOUT_ALL_USER") {
        return appReducer(initialState, action)
    }
    return appReducer(state, action)
}



export default rootReducer